import {AfterViewInit, Component} from '@angular/core';
import {AppService} from '../../services/app.service';

declare const $;

@Component({
  selector: 'pm-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit {

  constructor(
    private app: AppService
  ) {
    app.setTitle('QuickKicks Marketplace');
  }

  ngAfterViewInit(): void {
    this.init();
  }

  init(): void {
    $('.top_selling_slider').owlCarousel({
      loop: true,
      margin: 15,
      nav: true,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true
        },
        600: {
          items: 1,
          nav: true
        },
        768: {
          items: 2,
          nav: true
        },
        992: {
          items: 3,
          loop: false,
          margin: 10,
          nav: true
        },
        1200: {
          items: 3,
          // nav:true,
          loop: false,
          margin: 30
        }
      }
    });

    // parallax-scroll
    $(document).ready(() => {
      if ($(window).width() > 1200) {
        $(() => {
          $('.download_payouttt_container').parallaxScroll({friction: .10, direction: 'vertical'});
        });
      }
    });

    // owl-carousel nav (disabled) remove class js not working nav
    $('.owl-carousel .owl-nav').removeClass('disabled');

    $('.banner-top-sec').owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        992: {
          items: 1
        }
      }
    });
  }
}
